import api from "./api";
import {iniciarRequisicao, logout} from "@/helpers";
import {STATUS_HTTP} from "@/api/statusHTTP";

export const buscarDetalhesProdutoDrp = async (params) => {
  const url = 'drp/produtos/detalhes';
  const {data, status} = await api.get(url, {params, headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.detalhes;
  }

  logout();
}

export const storeMudancaGrupo = async (parametros) => {
  const url = 'drp/calendario-separacao/feriados/mudanca-grupo';
  const { data, status } = await api.post(url, parametros, { headers: iniciarRequisicao() }).catch(() => logout());

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return data.datas_feriados;
}

export const getDatasDeFeriados = async () => {
  const url = 'drp/calendario-separacao/feriados';
  const { data, status } = await api.get(url, { headers: iniciarRequisicao() }).catch(() => logout());

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return data.datas_feriados;
}

export const storeCalendarioSeparacaoFeriados = async (parametros) => {
  const url = 'drp/calendario-separacao/feriados';
  const { data, status } = await api.post(url, parametros, { headers: iniciarRequisicao() }).catch(() => logout());

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return data.mundanca_grupo;
}

export const deleteCalendarioSeparacaoFeriados = async (parametros) => {
  const url = 'drp/calendario-separacao/feriados/delete';
  const { data, status } = await api.post(url, parametros, { headers: iniciarRequisicao() }).catch(() => logout());

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return ;
}

class DrpAPI {
  async getFiliaisDrp(headers, params) {
    const response = await api.get("/getFiliaisDrp_", { params, headers });
    return response;
  }

  async ajustarParametros(headers, params) {
    const response = await api({
      method: "post",
      url: "/ajustar_parametros_",
      headers,
      data: params
    });
    return response;
  }

  async getDrpAutomatico(headers, params) {
    const response = await api.get("/getDrp_", { params, headers });
    return response;
  }

  async getDrpParametrizado(headers, params) {
    const response = await api.post("/getDrpParametrizado_", params, { headers });

    return response;
  }

  async getProdutoDispDrp(headers, params) {
    const response = await api.get("/getProdutoDispDrp_", { params, headers });
    return response;
  }

  async getGruposDrp(headers, params = {}) {
    const response = await api.get("/getGruposDrp_", { headers, params });
    return response;
  }

  //verificar se existe pedido
  async getStatusPedido(headers, params) {
    const response = await api.get("/getStatusPedido_", { params, headers });
    return response;
  }

  async addItemPedido(headers, params) {
    const response = await api({
      method: "post",
      url: "/addItemPedido_",
      headers,
      data: params
    });
    return response;
  }

  async getPedido(headers, params) {
    const response = await api.get("/getPedido_", { params, headers });
    return response;
  }

  async delItemPedido(headers, params) {
    const response = await api({
      method: "delete",
      url: "/delItemPedido_",
      headers,
      data: params
    });
    return response;
  }

  async delMultPedido(headers, params) {
    const response = await api({
      method: "delete",
      url: "/delMultPedido_",
      headers,
      data: params
    });
    return response;
  }
  // distribuicao drp

  async finalizar(headers, params) {
    const response = await api({
      method: "post",
      url: "/finalizar_",
      headers,
      data: params
    });
    return response;
  }

  async getFornecedores(headers, params) {
    const response = await api.get("/getFornecedoresDrp_", { headers, params });
    return response;
  }

  async atualizarEmbalagemMaster(headers, params) {
    const response = await api({
      method: "post",
      url: "/atualizar_embalagem_master",
      headers,
      data: params
    });
    return response;
  }

  async getDataInicialFinal(headers) {
    const response = await api.get("/get_data_inicial_final", { headers });
    return response;
  }

  async getAnosRelatorio(headers) {
    const response = await api.get("/get_anos_relatorio", { headers });
    return response;
  }

  async getUltimasComprasFornecedorGrupo(headers, params) {
    const response = await api.get("/get_ultimas_compras_fornecedor_grupo", {
      headers,
      params
    });
    return response;
  }

  async separacaoAutomaticaItens(headers, params) {
    return await api({
      method: "post",
      url: "/separacao_auto",
      headers,
      data: params
    });
  }

  // Transporte
  async getTransporte(headers, params) {
    const response = await api.get("drp/transporte", { params, headers });
    return response;
  }
  async deleteTransporte(headers, params) {
    const response = await api({
      method: "delete",
      url: "drp/transporte/" + params,
      headers
    });
    return response;
  }
  async createTransporte(headers, params) {
    const response = await api({
      method: "POST",
      url: "drp/transporte",
      headers,
      data: params
    });
    return response;
  }
  async updateTransporte(headers, params) {
    const response = await api({
      method: "PUT",
      url: "drp/transporte/" + params.id,
      headers,
      data: params
    });
    return response;
  }

  // GrupoSeparacao
  async getGrupoSeparacao(headers, params = {}) {
    const response = await api.get("drp/grupo_separacao", { params, headers });
    return response;
  }
  async deleteGrupoSeparacao(headers, params) {
    const response = await api({
      method: "delete",
      url: "drp/grupo_separacao/" + params,
      headers
    });
    return response;
  }
  async createGrupoSeparacao(headers, params) {
    const response = await api({
      method: "POST",
      url: "drp/grupo_separacao",
      headers,
      data: params
    });
    return response;
  }
  async updateGrupoSeparacao(headers, params) {
    const response = await api({
      method: "PUT",
      url: "drp/grupo_separacao/" + params.id,
      headers,
      data: params
    });
    return response;
  }

  // GrupoSeparacaoFilial
  async getGrupoSeparacaoFilial(headers, params) {
    const response = await api.get("drp/grupo_separacao_filial", {
      params,
      headers
    });
    return response;
  }
  async deleteGrupoSeparacaoFilial(headers, params) {
    const response = await api({
      method: "delete",
      url: "drp/grupo_separacao_filial/" + params,
      headers
    });
    return response;
  }
  async createGrupoSeparacaoFilial(headers, params) {
    const response = await api({
      method: "POST",
      url: "drp/grupo_separacao_filial",
      headers,
      data: params
    });
    return response;
  }
  async buscarFiliaisGrupoSeparacao(headers, params) {
    const response = await api.get("drp/grupo_separacao_filial/filiais-grupo-separacao", {
      params,
      headers
    });
    return response;
  }

  // CalendarioSeparacao
  async getCalendarioSeparacao(headers, params) {
    const response = await api.get("drp/calendario_separacao", {
      params,
      headers
    });
    return response;
  }
  async createCalendarioSeparacao(headers, params) {
    const response = await api({
      method: "POST",
      url: "drp/calendario_separacao",
      headers,
      data: params
    });
    return response;
  }

  async excluirGrupoSeparacaoDoDiaCalendario(headers, id) {
    return await api.delete(`drp/calendario_separacao/${id}`, {headers: iniciarRequisicao()}).catch(logout);
  }

  async atualizarDataGrupoSeparacao(headers, params) {
    return await api.put(`drp/calendario_separacao/${params.id}`, params, {headers: iniciarRequisicao()}).catch(logout);
  }

  async getFiliaisSeparacao(headers) {
    const response = await api.get("drp_get_filiais_separacao", {headers});
    return response;
  }

  async setFiliaisSeparacao(headers, params) {
    const response = await api({
      method: "POST",
      url: "drp_set_filiais_separacao",
      headers,
      data: params
    });
    return response;
  }

  async deleteFiliaisSeparacao(headers, params) {
    const response = await api({
      method: "DELETE",
      url: "drp_delete_filiais_separacao",
      headers,
      data: params
    });
    return response;
  }

  async verificarSeparacaoAtualDoProduto (headers, params) {
    const response = await api.get("/verificar_separacao_atual_do_produto", { params, headers });
    return response;
  }

  async getConfiguracaoDRP(headers) {
    const response = await api.get("/get_configuracao_drp", { headers });
    return response;
  }

  async getConfigProduto(headers, params) {
    return await api.get("/drp/get_config_dis_produto", {params, headers});
  }

  async setConfigProduto(headers, params) {
    return await api({
      method: "post",
      url: "/drp/produto",
      headers,
      data: params
    });
  }
}

export default new DrpAPI();
